import { useMemo } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import { MainDrawer } from 'components/Drawer/MainDrawer';
import { Header } from 'components/Header';
import { mainHeaderHeight } from 'theme/constants';
import { useWindowSize } from 'hooks/useWindowSize';
import { Main } from './Main';
import { headerSelector } from './selector';
import { PATH } from 'routes/path';

const offsetStyles = {
    height: mainHeaderHeight,
};

export const ProtectedLayout = () => {
    const { user, drawerIsOpen } = useSelector(headerSelector);

    const location = useLocation();

    return user ? (
        <Box width="100vw" overflow="auto">
            <Header open={drawerIsOpen} user={user} />
            <MainDrawer open={drawerIsOpen} />
            <Box>
                <Box sx={offsetStyles} />
                <Main open={drawerIsOpen} user={user}>
                    <Outlet />
                </Main>
            </Box>
        </Box>
    ) : (
        <Navigate to={PATH.LOGIN} replace state={{ from: location }} />
    );
};
